
import { Button } from "@/components/ui/button";
import { CreditsSection } from "@/components/CreditsSection";
import { MainLayout } from "@/components/layout/MainLayout";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { NewsSection } from "@/components/NewsSection";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "@/components/ui/use-toast";

const Index = () => {
  // Function to handle sending an email
  const handleSendEmail = () => {
    // Using mailto link to open default email client
    window.location.href = "mailto:nektarios@web-star.gr?subject=Επικοινωνία από την Ιστοσελίδα";
    
    // Show toast notification
    toast({
      title: "Άνοιγμα Email",
      description: "Το email client άνοιξε για να στείλετε μήνυμα στο nektarios@web-star.gr",
    });
  };

  return (
    <MainLayout>
      {/* Hero Section */}
      <section className="py-12 px-4 bg-primary text-white text-center rounded-lg mb-12">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">
          Ακαδημία Μηχανογράφησης
        </h1>
        <p className="text-xl mb-8 max-w-2xl mx-auto">
          Εδώ θα βρείτε υποστηρικτικό υλικό μηχανογράφησης των μεγαλύτερων εταιριών στην Ελλάδα
        </p>
        <Button 
          variant="secondary"
          size="lg"
          onClick={() => window.scrollTo({ top: document.getElementById('contact')?.offsetTop, behavior: 'smooth' })}
        >
          Επικοινωνήστε μαζί μας
        </Button>
      </section>

      {/* News Section */}
      <NewsSection />

      {/* Credits Section */}
      <section className="py-16 rounded-lg shadow-sm bg-white my-12">
        <CreditsSection />
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 bg-secondary rounded-lg">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-center mb-12">Επικοινωνήστε μαζί μας</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Card>
              <CardContent className="pt-6">
                <div className="flex flex-col items-center text-center space-y-3">
                  <Phone className="h-8 w-8 text-primary mb-2" />
                  <CardTitle className="text-lg">Τηλέφωνο</CardTitle>
                  <p className="text-muted-foreground">2541083074</p>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <div className="flex flex-col items-center text-center space-y-3">
                  <Mail className="h-8 w-8 text-primary mb-2" />
                  <CardTitle className="text-lg">Email</CardTitle>
                  <p className="text-muted-foreground">nektarios@web-star.gr</p>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <div className="flex flex-col items-center text-center space-y-3">
                  <MapPin className="h-8 w-8 text-primary mb-2" />
                  <CardTitle className="text-lg">Διεύθυνση</CardTitle>
                  <p className="text-muted-foreground">Ανδρέα Δημητρίου 34-36</p>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <div className="flex flex-col items-center text-center space-y-3">
                  <Clock className="h-8 w-8 text-primary mb-2" />
                  <CardTitle className="text-lg">Ωράριο Λειτουργίας</CardTitle>
                  <p className="text-muted-foreground">Δευτέρα - Παρασκευή</p>
                  <p className="text-muted-foreground">09:00 - 17:00</p>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="mt-12 text-center">
            <Button 
              variant="outline" 
              size="lg" 
              className="min-w-[200px]"
              onClick={handleSendEmail}
            >
              <Mail className="mr-2 h-4 w-4" />
              Στείλτε μας μήνυμα
            </Button>
          </div>
        </div>
      </section>
    </MainLayout>
  );
};

export default Index;
